// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
const MessageContainer = (props: ReactProps) => (
    <div className="modal-dialog modal-md msg-container">{props.children}</div>
);

export default MessageContainer;